/* ── Quickadd feedback ── */
document.addEventListener("submit", function (e) {
  var form = e.target;
  if (!form.classList.contains("hrc-featured-quickadd")) return;

  var btn = form.querySelector(".hrc-featured-quickadd-btn");
  if (!btn) return;

  btn.classList.add("is-loading");

  setTimeout(function () {
    btn.classList.remove("is-loading");
    btn.classList.add("is-success");

    setTimeout(function () {
      btn.classList.remove("is-success");
    }, 1800);
  }, 500);
});
